module.exports = __webpack_public_path__ + "static/img/stamp_08.2eb1108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_08.jpg
// module id = q/GI
// module chunks = 7